import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { QueryKeys } from "config/query-keys";
import { getDocs, updateDoc, query, where, collection} from "firebase/firestore";
import { db } from "../../../firebase/firebase";
import { EnumeratorInterface } from "../Profile/dto";

export const updateEnumeratorAvailability = async ({ uid,  isAvailable,}: EnumeratorInterface): Promise<void> => {
  try {
    const userRef = collection(db, "user_infos",);
    const userQuery = query(userRef, where("uid", "==", uid));
    const querySnapshot = await getDocs(userQuery);

    if (querySnapshot.empty) {
      throw new Error("User not found");
    }

    console.log(isAvailable)

    const userDoc = querySnapshot.docs[0].ref;
    const updateData = isAvailable.status === true ? isAvailable : { status: false };

    await updateDoc(userDoc, {
      isAvailable: updateData,
    });

  } catch (error) {
    console.error("Failed to update enumerator profile:", error);
    throw new Error("Failed to update profile. Please try again.");
  }
};

export const useUpdateEnumeratorAvailability = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.ENUMERATOR] });
      notification.success({
        message: "Updated",
        description: "Availability has been successfully updated.",
      });
    },

    mutationFn: updateEnumeratorAvailability,
  });
};